import { render, staticRenderFns } from "./GranissatColorAdvisor.vue?vue&type=template&id=06457824&"
import script from "./GranissatColorAdvisor.vue?vue&type=script&lang=js&"
export * from "./GranissatColorAdvisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports